// @flow

import * as React from 'react';
import { useState } from 'react';
// $FlowFixMe[untyped-import]
import Script from 'next/script';

// fetch the builder.io data on the server
const fetchBuilderData = async (
  model: string,
  apiKey: string,
  pathname: string,
) => {
  const baseUrl = `https://cdn.builder.io/api/v3/html/${model}`;
  const queryParams = new URLSearchParams({
    url: pathname,
    apiKey,
    'userAttributes.urlPath': pathname,
    limit: '1',
  });

  const requestUrl = `${baseUrl}?${queryParams.toString()}`;

  const response = await fetch(requestUrl, {
    next: {
      tags: ['builder-component', model, [model, pathname].join('-')],
    },
  });

  if (!response.ok) {
    return null;
  }
  const data = await response.json();
  return data;
};

type Props = {|
  model: string,
  apiKey: string,
  pathname: string,
|};

const sanitizeHTML = (html?: string): string | null => {
  if (html != null) {
    const scriptPattern =
      /<script\s+async\s+src="https:\/\/cdn\.builder\.io\/js\/webcomponents"><\/script>/g;
    return html.replace(scriptPattern, '');
  }
  return null;
};

export const BuilderComponent = ({
  model,
  apiKey,
  pathname,
}: Props): React.Node => {
  const [data, setData] = useState(null);
  const isBuilderEditing = pathname.includes('preview=true');

  const pathWithoutParams = pathname.split('?')[0];

  if (!isBuilderEditing) {
    fetchBuilderData(model, apiKey, pathWithoutParams)
      .then(data => {
        setData(data?.data);
      })
      .catch(() => {
        setData(null);
      });
  }

  return isBuilderEditing ? (
    <>
      <Script
        src="https://cdn.builder.io/js/webcomponents"
        strategy="afterInteractive"
        async={true}
      />
      <builder-component model={model} api-key={apiKey}></builder-component>
    </>
  ) : (
    <div
      key={data?.modelId}
      dangerouslySetInnerHTML={{ __html: sanitizeHTML(data?.html) ?? '' }}
    />
  );
};
